"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarStyles = void 0;
var avatarContentStyles = {
    borderColor: "var(--surface-background-color, transparent)",
    borderRadius: "var(--avatar__border-radius, 9999px)",
    clipPath: "var(--avatar__clip-path, none)",
};
exports.avatarStyles = {
    image: function () {
        return avatarContentStyles;
    },
    label: function () {
        return avatarContentStyles;
    },
    icon: function () {
        return avatarContentStyles;
    },
    root: function () {
        return {
            backgroundColor: "var(--surface-background-color, transparent)",
        };
    },
};
//# sourceMappingURL=avatar-styles.js.map